var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretLeftSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.937744 9.05991C0.351807 8.47397 0.351807 7.52241 0.937744 6.93647L6.93774 0.936471C7.36899 0.505221 8.01118 0.378658 8.57368 0.613033C9.13618 0.847408 9.50181 1.39116 9.50181 2.00053V14.0005C9.50181 14.6052 9.13618 15.1537 8.57368 15.388C8.01118 15.6224 7.36899 15.4912 6.93774 15.0646L0.937744 9.0646V9.05991Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretLeftSolid);
export default __webpack_public_path__ + "static/media/caret-left-solid.6270defd5239d9c46689e737c2c8abbf.svg";
export { ForwardRef as ReactComponent };